export default {
  'overview.title': 'Overview',
  'overview.totalRevenue': 'Total revenue',
  'overview.totalRevenueHint': 'Paid amount in range',
  'overview.paidOnly': 'Paid orders only',
  'overview.totalOrders': 'Total orders',
  'overview.paidOrdersHint': '{n} paid',
  'overview.newOrders': 'New orders',
  'overview.newOrdersHint': 'Excl. renewals',
  'overview.subscriptionOrders': 'Subscription orders',
  'overview.subscriptionOrdersDesc': 'Orders placed with a subscription plan',
  'overview.oneTimeOrders': 'One-time orders',
  'overview.oneTimeOrdersDesc': 'Single non-subscription purchases',
  'overview.renewalOrders': 'Renewal orders',
  'overview.renewalOrdersHint': '{total} renewals in range',
  'overview.renewalAmount': 'Renewal amount',
  'overview.renewalAmountHint': 'Paid renewal amount',
  'overview.renewalTitle': 'Renewals',
  'overview.renewalHint': 'Renewed + upcoming',
  'overview.renewalCountDesc': 'Renewed in range',
  'overview.pendingCharge': 'Pending charges',
  'overview.pendingChargeDesc': 'Due to charge in range',
  'overview.share': '{pct} of new orders',
  'overview.ofRenewalTotal': '{pct} of total',
};
